import Vue from "vue";

import Download from "../../components/Download";//下载组件
Vue.component('Download', Download)

import Loading from "../../components/Loading";//loading组件
Vue.component('Loading', Loading)

import VueJsonp from "vue-jsonp";//跨域请求
Vue.use(VueJsonp);

import FastClick from 'fastclick'//解决点击延迟问题
FastClick.attach(document.body)
